module.exports = __webpack_public_path__ + "img/398.f7476120.jpg";